import axios from 'axios';
import { getStore } from './tools';
import { Message, MessageBox } from 'element-ui';
import * as Msg from '@/api/notify'
import { getToken, setToken, removeToken } from './auth'

axios.defaults.baseURL = "api";
axios.defaults.timeout = 100000 // 请求超时时间

axios.interceptors.request.use(config => {
    // 其它系统传来的token
    let tempUrl = `${window.location.origin}${window.location.pathname}${window.location.hash}${window.location.search}`;
    var afterUrl = tempUrl.substring(1);
    var afterEqualParam = afterUrl.substring(afterUrl.indexOf('?')+1).split('=')
    if(afterEqualParam.length > 0 && afterEqualParam[0] == 'k'){
        var afterEqual = afterUrl.substring(afterUrl.indexOf('=')+1);
    }else{
        var afterEqual = '';
    }
    let accessToken = getToken();
    if (!accessToken && !afterEqual) {
        config.headers.Authorization = ''
        // window.location.href = "https://xtbg.gdzwfw.gov.cn/_tif_logout?returnUrl=https://xtbg.gdzwfw.gov.cn/gdxzzfpc/law";
    }else {
        config.headers.Authorization = accessToken;
    }
    return config;
}, err => {
    Msg.notifyError('请求超时')
    return Promise.resolve(err);
});
axios.interceptors.response.use(response => {
    if (response.status === 200) {
        if (response.data) {
            if (response.data.status || response.data.code) {
                if (response.data.status == 200 || response.data.code == 200) {
                    return Promise.resolve(response.data);
                }
                else if (response.data.status == 401 || response.data.code == 401 || response.data.status == 511 || response.data.code == 511) {
                    if (response.data.msg.indexOf('鉴权') > -1) {
                        console.log('response ', response)
                        Msg.notifyError('访问的接口无权限！');
                    } else {
                        removeToken();
                        localStorage.clear();
                        // window.location.href = "https://xtbg.gdzwfw.gov.cn/_tif_logout?returnUrl=https://xtbg.gdzwfw.gov.cn/gdxzzfpc/law";
                    }
                    return Promise.resolve(response.data);
                }  else if (response.data.status == 999 || response.data.code == 999) { //长篇错误信息展示
                    // 简析 逗号改为换行
                    let testInfo = response.data.desc || response.data.data || response.data.msg;
                    let reg = /[,，]/g;
                    let str = testInfo.replace(reg,"<br/>");
                    // MessageBox.confirm(`${str}`, '导入失败', {
                    //     customClass:'common-message-box',
                    //     dangerouslyUseHTMLString: true,
                    //     showCancelButton: false,
                    //     showConfirmButton: false,
                    // })
                    return Promise.resolve(response.data);
                }else {
                    //  
                    // 加了逻辑，去除errorcode这种提示
                    let errTips = '';
                    if (response.data.desc && response.data.desc.indexOf('errorcode') > -1) {
                        // 这种情况不弹窗提示
                        // errTips = response.data.desc || response.data.data || response.data.msg;
                        // Msg.notifyError(errTips);
                    } else {
                        errTips = response.data.desc || response.data.data || response.data.msg;
                        Msg.notifyError(errTips);
                    }
                    // Msg.notifyError(response.data.desc || response.data.data || response.data.msg);
                    return Promise.resolve(response.data);
                }
            }else{// 附件下载返回流
                return Promise.resolve(response);  
            }
        }else{
            return Promise.resolve(response);  
        }
    } else if (response.status == 401) {
        localStorage.clear();
        Msg.notifyError('系统异常')
        return Promise.reject(response);
    }else if (response.status == 500) {
        localStorage.clear();
        Msg.notifyError(response.data)
    } else {
        return Promise.reject(response);
    }
}, (err) => {
    
    let response = err.response
    if (!response) {
        Msg.notifyError('系统异常')
        // MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        //     confirmButtonText: '重新登录',
        //     cancelButtonText: '取消',
        // }).then(() => {
        //     removeToken();
        //     // window.location.href = "https://xtbg.gdzwfw.gov.cn/_tif_logout?returnUrl=https://xtbg.gdzwfw.gov.cn/gdxzzfpc/law";
        //     // location.reload()// 为了重新实例化vue-router对象 避免bug
        // })
        return Promise.reject(response);
    } else if (response.data.code == 500) {
        return Promise.resolve(response.data);
    } else {
        return Promise.resolve(response.data);
    }
});

// 共用方法获取签名
function getSecret() {
    let nonce = getNonce()
    let timestamp = getTimestamp()
    let obj = {
      nonce: nonce,
      timestamp: timestamp,
    }
    return obj
}
// 随机字符串
function getNonce() {
    let alphabet = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM'
    let strlenght = 8 /// 生成的字符串固定长度
    let $num = ''
    for (var i = 0; i < strlenght; i++) {
      $num = $num + alphabet[Math.floor(Math.random() * alphabet.length)]
    }
    return $num
}
// 时间戳
function getTimestamp() {
    let timestamp = Date.parse(new Date()) / 1000
    return timestamp
}
export default axios
